import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ja: {
    translation: {
      // Login Page
      systemTitle: "TOMO人材管理システム",
      userLogin: "ユーザーログイン",
      username: "ユーザー名",
      password: "パスワード",
      usernamePlaceholder: "ユーザー名を入力してください",
      passwordPlaceholder: "パスワードを入力してください",
      login: "ログイン",
      loggingIn: "ログイン中...",
      unknownError: "未知のエラーが発生しました",
      appName: "TOMO人材管理",
      systemStatus: {
        normal: "システム稼働中"
      },
      weather: {
        sunny: "晴れ",
        rainy: "雨",
        snowy: "雪",
        windy: "強風"
      },
      enableEffects: "エフェクトON",
      disableEffects: "簡易モード",

      // Admin Dashboard
      adminDashboard: "管理者ダッシュボード",
      viewAllTalents: "すべての人材を表示",
      manageUsers: "ユーザー管理",
      viewAuditLogs: "操作ログを表示",
      functionInDevelopment: "機能開発中",
      selectManagementTask: "管理タスクを選択してください。",
      searchPlaceholder: "氏名、管理番号、国籍、所属機関、事業所、在職状況で検索...",
      backToHome: "ホームに戻る",
      updateNotifications: "更新・修正通知",
      dashboardInsights: {
        title: "データインサイト",
        subtitle: "主要な指標を可視化したサマリービュー",
        totalTalents: "人材総数: {{count}}名",
        generatedAt: "更新: {{value}}",
        statusTitle: "進捗状況の分布",
        nationalityTitle: "国籍 × 職種ツリー",
        funnelTitle: "進捗状況ファネル",
        funnelSubtitle: "各ステージの残存数とシェアを一目で把握できます",
        timelineTitle: "営業別の月次推移",
        timelineSubtitle: "直近12ヶ月の新規登録人数（営業担当ごと）",
        timelineTitleSelf: "自分の月次推移",
        timelineSubtitleSelf: "直近12ヶ月の自分の担当人材の新規登録人数",
        timelineTitleOverall: "全体の月次推移",
        timelineSubtitleOverall: "直近12ヶ月の人材総数の推移",
        noData: "表示できるデータがありません",
        loadError: "ダッシュボードデータの取得に失敗しました",
        unset: "未設定",
        peopleCount: "{{count}}名",
        timelineLegend: "累計 {{count}}名",
        timelineEmpty: "直近12ヶ月に表示できるデータがありません",
        timelineUnknownLabel: "未割当"
      },
      systemNotifications: {
        openManager: "更新通知を管理",
        managerTitle: "更新・修正通知管理",
        loadUsersFailed: "ユーザー一覧の取得に失敗しました",
        loadNotificationsFailed: "通知の取得に失敗しました",
        requiredFields: "タイトルと内容を入力してください",
        selectTargetsWarning: "少なくとも1名の送信先を選択してください",
        updateSuccess: "通知を更新しました",
        createSuccess: "通知を作成しました",
        saveFailed: "通知の保存に失敗しました",
        sendSuccess: "通知を送信しました",
        sendFailed: "通知の送信に失敗しました",
        deleteConfirm: "この通知を削除してもよろしいですか？",
        deleteSuccess: "通知を削除しました",
        deleteFailed: "通知の削除に失敗しました",
        editNotification: "通知を編集",
        createNotification: "通知を作成",
        title: "タイトル",
        titlePlaceholder: "通知のタイトルを入力",
        content: "内容",
        contentPlaceholder: "更新・修正内容を入力してください...",
        targets: "送信先",
        filterUsers: "ユーザー名・権限でフィルター...",
        noUsers: "該当するユーザーが見つかりません",
        cancelEdit: "編集をキャンセル",
        saving: "保存中...",
        updateButton: "通知を更新",
        createButton: "通知を作成",
        notificationList: "通知一覧",
        refresh: "再読み込み",
        emptyState: "通知はまだありません",
        createdAt: "作成日時: {{date}}",
        sentAt: "送信日時: {{date}}",
        readAt: "既読日時: {{date}}",
        status: {
          sent: "送信済み",
          draft: "下書き"
        },
        recipients: "送信先",
        editButton: "編集",
        sendButton: "送信",
        deleteButton: "削除",
        noReceived: "受信した通知はまだありません",
        unread: "未読",
        read: "既読",
        markAsRead: "既読にする",
        loadReceivedFailed: "通知の取得に失敗しました",
        markAsReadFailed: "通知を既読にできませんでした"
      },
      latestUpdates: "最新の更新情報",
      exportCSV: "CSVエクスポート",
      exportExcel: "Excel出力",
      exportingExcel: "Excel出力中...",
      exportExcelSuccess: "Excelファイルをダウンロードしました",
      exportExcelFailed: "Excel出力に失敗しました",
      exportSuccess: "CSVファイルをダウンロードしました",
      exportFailed: "CSVエクスポートに失敗しました",

      // Pagination
      totalRecords: "総件数",
      page: "ページ",
      previousPage: "前のページ",
      nextPage: "次のページ",
      firstPage: "最初",
      lastPage: "最後",
      pageInfo: "{{current}} / {{total}} ページ",
      showingResults: "{{start}} - {{end}} 件目 (全{{total}}件)",

      // Talent Table
      serialNumber: "No.",
      name: "氏名",
      managementNumber: "管理番号",
      affiliatedOrganization: "所属機関",
      nationality: "国籍",
      employmentStatus: "進歩状況",
      responsibleSales: "責任担当",
      responsibleSalesRequired: "担当営業を選択してください。",
      actions: "操作",
      view: "表示",
      edit: "編集",
      viewEdit: "表示・編集",
      delete: "削除",
      deleting: "削除中...",
      loadingTalentData: "人材データを読み込み中...",
      noTalentDataFound: "関連する人材データが見つかりません。",
      deleteConfirmation: "この人材を削除してもよろしいですか？この操作は取り消せません。",
      deleteConfirmationTitle: "人材削除確認",
      deleteConfirmationMessage: "{{name}} さんのデータを削除しますか？この操作は取り消せません。",
      deleteSuccess: "{{name}} さんのデータが削除されました",
      deleteFailed: "削除に失敗しました",
      notRegistered: "未登録",
      notAssigned: "未割当",

      // Audit Log Table
      operationTime: "操作時刻",
      operator: "操作者",
      operationType: "操作タイプ",
      targetObject: "対象オブジェクト",
      details: "詳細",
      loadingAuditLogs: "操作ログを読み込み中...",
      noAuditLogsFound: "操作ログデータが見つかりません。",
      fetchAuditLogsFailed: "操作ログの取得に失敗しました",

      // Layout
      logout: "ログアウト",

      // Sales Dashboard
      salesDashboard: "営業ダッシュボード",

      // Shared Dashboard
      sharedDashboard: "共有ダッシュボード",

      // Common
      loading: "読み込み中...",
      error: "エラー",
      success: "成功",
      cancel: "キャンセル",
      confirm: "確認",
      save: "保存",
      close: "閉じる",
      backToList: "一覧に戻る",
      create: "作成",
      update: "更新",

      // Talent Detail Modal
      talentDetails: "人材詳細",
      personalInfo: "個人情報",
      phoneNumber: "電話番号",
      email: "メールアドレス",
      birthDate: "生年月日",
      gender: "性別",
      address: "住所",
      emergencyContact: "緊急連絡先",
      addressSelector: {
        prefecture: "都道府県",
        selectPrefecture: "都道府県を選択...",
        city: "市区町村",
        selectCity: "市区町村を選択...",
        detailAddress: "詳細住所",
        detailAddressPlaceholder: "町名・番地・建物名など",
        fullAddress: "完全住所",
        notSelected: "未選択"
      },

      // Residence Permit
      residencePermitInfo: "在留許可情報",
      permitType: "許可種類",
      expiryDate: "有効期限",
      status: "ステータス",

      // Loan Information
      loanInfo: "貸付情報",
      loanAmount: "貸付金額",
      repaymentStatus: "返済状況",
      activeLoan: "現在の貸付",
      loanHistory: "貸付履歴",
      completedLoans: "完了済み貸付",
      viewHistory: "履歴を表示",
      viewCurrent: "現在の貸付を表示",
      markAsCompleted: "完了としてマーク",
      loanStatus: "貸付状態",
      active: "進行中",
      completed: "完了済み",
      completedDate: "完了日",

      // Create/Edit Talent Modal
      createTalent: "人材登録",
      editTalent: "人材編集",
      required: "必須",
      fullName: "氏名（フルネーム）",
      managementNo: "管理番号",
      selectNationality: "国籍を選択",
      selectGender: "性別を選択",
      male: "男性",
      female: "女性",
      other: "その他",

      // Attachments
      attachments: "添付ファイル",
      uploadFile: "ファイルをアップロード",
      downloadFile: "ファイルをダウンロード",
      deleteFile: "ファイルを削除",

      // Additional translations
      welcome: "ようこそ",
      startWork: "上のボタンをクリックして作業を開始してください。",
      myTalents: "私の人材を表示",
      newTalent: "人材登録",
      searchNameNumber: "氏名、管理番号、国籍などで検索...",

      // Success/Error Messages  
      saveSuccess: "保存しました",
      updateSuccess: "更新しました",
      // deleteSuccess: "削除しました", // 重複キー削除
      createSuccess: "作成しました",
      loginSuccess: "ログインしました",
      logoutSuccess: "ログアウトしました",
      uploadSuccess: "アップロードしました",
      downloadSuccess: "ダウンロードしました",

      saveFailed: "保存に失敗しました",
      updateFailed: "更新に失敗しました",
      createFailed: "作成に失敗しました",
      loginFailed: "ログインに失敗しました。ユーザー名またはパスワードが正しくありません。",
      loadFailed: "読み込みに失敗しました",
      uploadFailed: "アップロードに失敗しました",
      downloadFailed: "ダウンロードに失敗しました",
      fetchFailed: "取得に失敗しました",

      // Loading states
      saving: "保存中...",
      updating: "更新中...",
      creating: "作成中...",
      uploading: "アップロード中...",
      downloading: "ダウンロード中...",
      processing: "処理中...",

      // Form sections
      costs: "費用",
      residenceInfo: "在留情報",
      workplace: "事業所",

      // Field labels
      fullNameFurigana: "氏名（フリガナ）",
      residenceAddress: "住所",
      workplaceAddress: "事業所住所",
      organizationName: "機関名",
      organizationPhone: "機関電話番号",
      organizationEmail: "機関メールアドレス",
      organizationContact: "機関担当者",
      workplaceName: "事業所名",
      workplacePhone: "事業所電話番号",
      workplaceEmail: "事業所メールアドレス",
      workplaceContact: "事業所担当者",
      workplaceContactTitle: "事業所担当者役職",
      initialCost: "初期費用",
      introductionFee: "紹介費",
      managementFee: "管理費",
      charged: "課金",
      noCharge: "無償",
      initialCostNotCharged: "初期費無償設定",
      managementFeeNotCharged: "管理費無償設定",
      managementFeeNotChargedHint: "無償設定時は管理費関連項目を自動でクリアします",
      firstMonthManagementFee: "首月管理費",
      firstMonthManagementFeeHint: "初月の管理費は日割りや営業判断に合わせて手動で入力してください",
      billingPlanType: "料金プラン",
      billingPlanTypeNormal: "通常",
      billingPlanTypeInitialPlus: "初期費+Nヶ月管理費",
      billingPlanTypeTiered: "段階管理費",
      includedManagementMonths: "管理費含む月数",
      tier1Months: "第1段階(月数)",
      tier1ManagementFee: "第1段階管理費",
      tier2Months: "第2段階(月数)",
      tier2ManagementFee: "第2段階管理費",
      contractEndDate: "契約終了日",
      employmentPauseType: "休止区分",
      employmentPauseTypeNone: "なし",
      employmentPauseTypeChildcare: "育休",
      employmentPauseTypeTemporaryReturn: "一時帰国",
      employmentPauseStartDate: "休止開始日",
      employmentPauseEndDate: "休止終了日",
      employmentPauseHint: "休止区分がある場合、期間を入力してください",
      billingTrend: "管理費推移",
      billingTrendRange: "{{start}} 〜 {{end}}",
      billingTrendLoading: "管理費推移を読み込み中...",
      billingTrendNoData: "管理費推移データがありません",
      billingTrendError: "管理費推移の取得に失敗しました",
      billingTrendSeriesLabel: "管理費",
      billingTrendBilledLabel: "請求月",
      billingTrendPausedLabel: "休止月",
      billingTrendNoChargeLabel: "非請求月",

      // Fee Change (管理費変更)
      feeChangeHistory: "管理費変更履歴",
      feeChangeAdd: "追加",
      feeChangeEffectiveMonth: "生効月",
      feeChangeNewFee: "変更後金額",
      feeChangeNote: "備考",
      feeChangeCreatedBy: "作成者",
      feeChangeCreatedAt: "作成日時",
      feeChangeDelete: "削除",
      feeChangeNoRecords: "変更履歴はありません",
      feeChangeAddTitle: "新規管理費変更",
      feeChangeAddButton: "追加",
      feeChangeAdding: "追加中...",
      feeChangeAddSuccess: "管理費変更を追加しました",
      feeChangeAddFailed: "管理費変更の追加に失敗しました",
      feeChangeDeleteConfirm: "この変更記録を削除してもよろしいですか？",
      feeChangeDeleteSuccess: "管理費変更を削除しました",
      feeChangeDeleteFailed: "管理費変更の削除に失敗しました",
      feeChangeLoadFailed: "管理費変更履歴の取得に失敗しました",
      baseFeeLockHint: "管理費変更履歴があるため、基準管理費はロックされています。",
      baseFeeUnlockButton: "基準管理費を修正",
      baseFeeUnlockConfirm: "管理費変更履歴があります。基準管理費の編集モードを有効化しますか？この変更は生効月以前の計算に影響します。",
      baseFeeSaveConfirm: "基準管理費を変更します。既存の管理費変更履歴の生効月以前に影響します。続行しますか？",
      baseFeeLockedError: "管理費変更履歴があるため、基準管理費を直接保存できません。まず「基準管理費を修正」を選択してください。",

      // Status and options
      jobOffer: "内定",
      applying: "申請中",
      employed: "在職",
      unemployed: "離職",
      childcareLeave: "育休",
      temporaryReturn: "一時帰国",
      awaitingEntry: "待入社",
      unknown: "未知",
      unregistered: "未登録",
      pleaseSelect: "選択してください...",

      // Residence permit fields
      applicationDate: "申請日",
      grantDate: "交付日",
      applicationMethod: "申請方法",
      applicationNumber: "申請番号",
      applicant: "申請者",
      residenceCardNumber: "在留カード番号",
      residenceCardExpiry: "在留カード有効期限",
      passportNumber: "パスポート番号",
      passportExpiry: "パスポート有効期限",
      interviewDate: "面接日",
      startDate: "入職日",
      endDate: "退職日",
      employmentDays: "在職日数",
      renewalDate: "更新日",
      renewalGrantDate: "更新交付日",
      remainingDays: "残り日数",

      // Loan fields
      totalAmount: "総額",
      loanDetails: "貸付詳細",
      loanDate: "貸付日",
      repaymentStartDate: "返済開始日",
      repaymentEndDate: "返済終了日",
      plannedRepaymentEndDate: "予定返済終了日",
      remainingBalance: "残高",
      rentalLoanAmount: "賃貸貸付額",
      advanceLoanAmount: "立替金",
      repaymentHistory: "返済履歴",
      repaymentDate: "返済日",
      repaymentAmount: "返済金額",
      loanEntries: "借款一覧",
      addLoanEntry: "＋追加借款",
      loanEntryCategory: "分類",
      loanSubjectType: "借款主体",
      repaymentSubjectType: "返済主体",
      individualSubject: "個人",
      corporateSubject: "法人",
      totalLabel: "合計",
      loanEntryNote: "借款説明",
      loanEntryDocuments: "書類",
      unlinkedLoanAttachments: "未紐付け書類",
      autoCalculated: "自動計算",
      manualSetting: "手動設定",
      switchToAuto: "自動計算に戻す",

      // File operations
      selectFiles: "ファイルを選択",
      noFilesSelected: "ファイルが選択されていません",
      selectedFilesCount: "{{count}}件のファイルを選択中",
      uploadFiles: "ファイルをアップロード",
      download: "ダウンロード",
      preview: "プレビュー",
      viewOnline: "オンライン閲覧",
      filePreviewTitle: "ファイル閲覧",
      filePreviewUnsupported: "このファイル形式はオンライン閲覧に対応していません。",
      filePreviewDownloadHint: "ダウンロードして内容を確認してください。",
      filePreviewTextFailed: "テキストの読み込みに失敗しました。",
      filePreviewPdfFailed: "PDFの読み込みに失敗しました。",
      filePreviewPdfPage: "{{page}} / {{total}} ページ",

      // Confirmation messages
      confirmDelete: "削除してもよろしいですか？この操作は取り消せません。",
      confirmSave: "保存してもよろしいですか？",
      confirmUpdate: "更新してもよろしいですか？",
      confirmMarkAsCompleted: "この貸付を完了としてマークしますか？",
      markCompletedSuccess: "貸付を完了としてマークしました",
      markCompletedFailed: "完了マークに失敗しました",
      noLoanHistory: "貸付履歴はありません",
      viewDetails: "詳細を表示",

      // Map related
      talentMap: "人材マップ",
      listView: "リスト表示",
      regionView: "都道府県別",
      mapView: "地図表示",
      totalTalents: "合計人材数",
      activeRegions: "活動地域数",
      currentlyDisplayed: "表示中",
      allRegions: "全地域",
      talentDistributionMap: "人材分布地図",
      clickForDetails: "ピンをクリックして詳細情報を表示",
      loadingMap: "地図を読み込み中...",
      mapDescription: "ピン位置: 事業所 | ピン色: 出身地 | ピンをクリックして詳細情報を表示",
      mapLegendTitle: "出身地凡例",
      mapOriginFilterLabel: "出身地",
      mapOriginFilterAll: "すべての出身地",
      originPlace: "出身地",
      originUnset: "未設定",
      noTalentsWithAddress: "住所情報が登録されている人材がありません。",
      mappedTalents: "分類済み",
      unmappedTalents: "未分類",
      unmappedNote: "事業所住所が未登録",

      // Dashboard
      dashboard: "ダッシュボード",
      batchImport: "一括インポート",
      talentMapFeature: "人材マップ",

      // Nationality options
      japanese: "日本",
      chinese: "中国",
      korean: "韓国",
      vietnamese: "ベトナム",
      filipino: "フィリピン",
      thai: "タイ",
      myanmar: "ミャンマー",
      indonesia: "インドネシア",
      taiwan: "台湾",

      // Field/Industry options
      restaurant: "外食",
      foodManufacturing: "飲食料品製造",
      welding: "溶接",
      care: "介護",
      otherField: "他",
      field: "分野",
      customField: "カスタム分野",
      pleaseEnterCustomField: "カスタム分野を入力してください",

      // Transfer talent functionality
      transferTalent: "人材譲渡",
      talentInfo: "人材情報",
      currentSales: "現在の担当",
      transferToSales: "譲渡先営業",
      transferConfirmation: "譲渡確認",
      transferConfirmationMessage: "{talent} を {from} から {to} に譲渡します。よろしいですか？",
      confirmTransfer: "譲渡実行",
      transferring: "譲渡中...",
      loadSalesUsersFailed: "営業員リストの読み込みに失敗しました",
      transferTalentFailed: "人材譲渡に失敗しました",
      pleaseSelectSales: "譲渡先の営業員を選択してください",

      // Error messages
      invalidInput: "入力が無効です",
      networkError: "ネットワークエラーが発生しました",
      serverError: "サーバーエラーが発生しました",
      permissionDenied: "権限がありません",
      fileNotFound: "ファイルが見つかりません",
      invalidFileType: "無効なファイル形式です",
      fileSizeExceeded: "ファイルサイズが上限を超えています",

      // General UI
      search: "検索",
      filter: "フィルター",
      sort: "ソート",
      refresh: "更新",
      clear: "クリア",
      reset: "リセット",
      previous: "前へ",
      next: "次へ",
      finish: "完了",
      back: "戻る",
      retry: "再試行",

      // Table headers
      lastUpdated: "最終更新日",
      createdAt: "作成日",

      // Validation messages
      fieldRequired: "この項目は必須です",
      invalidEmail: "有効なメールアドレスを入力してください",
      invalidPhone: "有効な電話番号を入力してください",
      invalidDate: "有効な日付を入力してください",
      employmentPauseDateRangeError: "休止開始日は休止終了日以前で指定してください",

      // Shared Dashboard translations
      registerViewResidenceInfo: "在留情報の登録/確認",
      registerUpdateLoan: "貸付金の登録/更新",
      residenceManagement: "在留管理",
      accountingManagement: "立替金管理",
      selectTalentPrompt: "下のボタンをクリックして操作する人材を選択してください。",

      // Additional modal translations
      selectTalent: "人材を選択",
      repaymentCount: "返済回数",
      newRepayment: "新規返済",
      actualRepaymentRecord: "実際返済記録",
      loanManagement: "貸付管理",
      none: "なし",
      feedbackPrompt: "「あれ？」っと思ったら、とりあえずリフレッシュ！まだ「あれ？」が続くなら、再ログインしてみてください。万策尽きたら、こちらへどうぞ！",
      contactSupport: "サポートへ連絡",
      edited: "編集済み",
      notEdited: "未編集",
      residenceEditStatus: "在留情報編集状況",
      loanRegistered: "借款登記済み",
      loanNotRegistered: "未登記借款",
      loanFullyRepaid: "完済済み",
      lastRepaymentDate: "最終返済日",
      withRepayment: "返済記録有り",
      loanAttachments: "借款関連書類",
      uploadAttachments: "書類をアップロード",
      deleteAttachment: "削除",
      downloadAttachment: "ダウンロード",

      // User Management (SuperAdmin only)
      userManagement: {
        title: "ユーザー管理",
        username: "ユーザー名",
        role: "役割",
        actions: "操作",
        rename: "名前変更",
        resetPassword: "パスワードリセット",
        delete: "削除",
        save: "保存",
        cancel: "キャンセル",
        createNewUser: "新規ユーザーを作成",
        createUser: "ユーザー作成",
        password: "パスワード",
        selectRole: "役割を選択",

        // Role translations
        roleSuperAdmin: "スーパー管理者",
        roleAdmin: "管理者",
        roleSales: "営業",
        roleResidence: "在留",
        roleAccounting: "会計",

        // Placeholders
        newPasswordPlaceholder: "新しいパスワード",
        usernamePlaceholder: "ユーザー名を入力",
        passwordPlaceholder: "パスワードを入力（6文字以上）",

        // Messages
        usernameCannotBeEmpty: "ユーザー名を入力してください",
        passwordCannotBeEmpty: "パスワードを入力してください",
        roleCannotBeEmpty: "役割を選択してください",
        userCreatedSuccess: "ユーザー「{{username}}」を作成しました",
        userCreateFailed: "ユーザーの作成に失敗しました",
        usernameUpdatedSuccess: "ユーザー名を変更しました",
        usernameUpdateFailed: "ユーザー名の変更に失敗しました",
        passwordMinLength: "パスワードは6文字以上で入力してください",
        confirmPasswordReset: "このユーザーのパスワードをリセットしてもよろしいですか？",
        passwordResetSuccess: "パスワードをリセットしました",
        passwordResetFailed: "パスワードリセットに失敗しました",
        confirmDeleteUser: "ユーザー「{{username}}」を削除してもよろしいですか？この操作は取り消せません。",
        userDeletedSuccess: "ユーザー「{{username}}」を削除しました",
        userDeleteFailed: "ユーザーの削除に失敗しました",
        fetchUsersFailed: "ユーザーリストの取得に失敗しました",
        noUsersFound: "ユーザーが見つかりません"
      },

      jobSeekers: {
        title: "求職登録",
        description: "ホームページからの求職登録・履歴書",
        notice: "登録内容・書類は担当者のみが扱ってください。不要になった登録は書類と合わせて削除してください。",
        empty: "登録はまだありません。",
        submittedAt: "受付日時",
        name: "氏名",
        attachments: "添付",
        documentCount: "{{count}}書類",
        notification: "通知",
        receipt: "受付メール",
        delivered: "送信済み",
        failed: "未送信",
        unknown: "不明",
        previous: "前へ",
        next: "次へ",
        deleted: "登録と添付書類を削除しました。",
        delete: "登録と書類を削除",
        confirm: "{{name}} 様の登録と添付書類を削除します。この操作は元に戻せません。",
        resume: "履歴書をダウンロード",
        history: "職務経歴書をダウンロード",
        missing: "未入力",
        company: "会社名",
        period: "在籍期間",
        current: "在職中",
        employment: "雇用形態",
        position: "役職",
        duties: "職務内容",
        age: "{{count}}歳",
        salary: "{{value}}万円",
        agreed: "同意済み",
        later: "後日提出",
        fields: {
          registration_date: "内容登録日",
          family_name: "姓",
          given_name: "名",
          family_name_kana: "セイ",
          given_name_kana: "メイ",
          nationality: "国籍",
          nationality_other: "国籍（その他）",
          gender: "性別",
          birth_date: "生年月日",
          age: "年齢",
          postal_code: "郵便番号",
          address: "都道府県・市区町村・町域",
          address_detail: "番地・建物名・部屋番号",
          phone: "電話番号",
          email: "メールアドレス",
          contact_methods: "希望する連絡方法",
          education: "最終学歴",
          employment_status: "現在の就業状況",
          transfer_timing: "転職希望時期",
          job_search_status: "転職活動状況",
          preferred_location_1: "希望勤務地・第一希望",
          preferred_location_2: "希望勤務地・第二希望",
          preferred_location_3: "希望勤務地・第三希望",
          desired_job_category: "希望職種（分野）",
          desired_job: "希望職種",
          desired_job_other: "希望職種（その他）",
          current_salary: "現年収",
          desired_salary: "希望年収",
          employment_types: "希望する雇用形態",
          employment_other: "その他の雇用形態",
          experiences: "職務経験",
          language_skills: "語学力",
          pc_skills: "PCスキル",
          pc_other: "その他のPCスキル",
          qualifications: "保有資格",
          transfer_reason: "転職理由",
          self_pr: "自己PR",
          resume_later: "履歴書の後日提出",
          privacy_consent: "個人情報の取扱いへの同意"
        }
      },

      clientManagement: {
        quickAction: "取引先管理",
        title: "取引先管理",
        subtitle: "所属機関と事業所を一元管理します",
        searchPlaceholder: "機関名・事業所名で検索...",
        syncFromTalents: "既存取引先に再リンク",
        organizationList: "機関一覧",
        organizationInfo: "機関情報",
        newOrganization: "新規機関",
        noOrganizations: "取引先がまだありません",
        noOrganizationsHint: "「新規機関」から取引先を登録してください。",
        noOrganizationSelected: "機関を選択してください",
        noOrganizationSelectedHint: "左側から機関を選ぶと詳細と関連人材を表示します。",
        noMatchingOrganizations: "一致する機関がありません",
        workplaceList: "事業所一覧",
        workplaceInfo: "事業所情報",
        newWorkplace: "新規事業所",
        noWorkplaces: "事業所はまだありません",
        noWorkplaceSelected: "事業所を選択してください",
        noWorkplaceSelectedHint: "一覧から事業所を選ぶか、新規作成してください。",
        relatedTalents: "関連人材",
        talentsEmpty: "関連する人材はまだいません",
        filteredTalents: "{{name}} の関連人材",
        allWorkplaces: "すべての事業所",
        clearWorkplaceFilter: "フィルター解除",
        organizationContracts: "所属機関契約書",
        workplaceContracts: "事業所契約書",
        talentContracts: "人材契約書",
        contractAction: "契約書",
        uploadContracts: "契約書をアップロード",
        noContracts: "契約書がありません",
        noWorkplaceContractsHint: "事業所を選択すると契約書を管理できます。",
        organizationContractsDisabledHint: "機関を保存または選択すると契約書を管理できます。",
        workplaceContractsDisabledHint: "事業所を保存または選択すると契約書を管理できます。",
        contractSectionHint: "複数ファイルを保持したまま履歴管理できます。",
        contractFilesSelected: "選択中のファイル {{count}}件",
        uploadedBy: "アップロード者",
        uploadedAt: "アップロード日時",
        fileSize: "ファイルサイズ",
        contractDeleteConfirm: "この契約書を削除しますか？この操作は取り消せません。",
        openTalentContracts: "{{name}} の契約書を管理",
        talentContractDescription: "この人材に紐づく契約書をアップロード・確認します。",
        organizationDeleteConfirm: "この機関を削除しますか？関連人材の所属機関・事業所情報もクリアされます。",
        workplaceDeleteConfirm: "この事業所を削除しますか？関連人材の事業所情報もクリアされます。",
        selectOrganizationFirst: "先に機関を選択してください",
        linkedTalentCount: "関連人材 {{count}}名",
        workplaceCount: "事業所 {{count}}件"
      },

      // Admin Analytics
      adminAnalytics: {
        title: "管理者統計",
        loadError: "データの読み込みに失敗しました",
        errorOccurred: "エラーが発生しました",

        // Management Fee Statistics
        managementFeeStats: "管理費統計",
        managementFeeFilterLabel: "表示対象",
        allSalesStaff: "全営業担当",
        managementFeeCurrentView: "表示対象: {{salesStaff}}（対象人材: {{count}}名）",
        managementFeeCurrentViewActive: "表示対象: {{salesStaff}}（在職人材: {{count}}名）",
        managementFeeViewLabel: "統計視角",
        managementFeeViewOption: {
          current: "当月実績",
          rangeActual: "区間実績",
          rangeForecast: "区間見込",
          rangeCombined: "区間総合"
        },
        managementFeeViewRange: "統計期間: {{start}} 〜 {{end}}",
        managementFeeViewFeeCount: "{{view}}管理費対象: {{count}}名",
        startMonth: "開始月",
        endMonth: "終了月",
        clearDateFilters: "リセット",
        applyDateFilters: "適用",
        invalidDateRange: "開始月は終了月以前で指定してください",
        totalMonthlyFee: "月間管理費総額",
        totalRangeFee: "区間管理費総額",
        averageFeePerTalent: "人材あたり平均",
        medianFee: "管理費中央値",
        maxFee: "最高管理費",
        minFee: "最低管理費",
        projectedAnnualRevenue: "年間予想収益",
        firstMonthFeeTotal: "首月管理費合計",
        firstMonthFeeCount: "首月管理費適用: {{count}}件",
        managementFeeCurrentMonthCount: "当月管理費対象: {{count}}名",
        managementFeeNoChargeCount: "管理費無償設定: {{count}}名",
        managementFeeOtherCount: "管理費非請求・対象外: {{count}}名",
        managementFeeCurrentViewHint: "当月実績は現在月のみ集計され、期間指定の影響を受けません。",
        managementFeeCurrentRangeDisabledHint: "当月実績では期間指定を使用しません。区間視角を選択すると有効になります。",
        billedMonths: "請求月数",
        pausedMonths: "休止月数",
        monthsUnit: "ヶ月",

        // Initial Cost Statistics
        initialCostStats: "初期費用統計",
        initialCostSyncLabel: "管理費と同じ条件を使用",
        totalInitialCost: "初期費用合計",
        averageInitialCost: "人材あたり平均",
        medianInitialCost: "初期費用中央値",
        maxInitialCost: "最高初期費用",
        minInitialCost: "最低初期費用",
        initialCostTalentCount: "初期費用対象人数",
        initialCostCoverageRate: "入力率: {{rate}}%",
        initialCostNoChargeCount: "初期費無償設定: {{count}}名",
        initialCostChargeablePopulation: "集計対象母数: {{count}}名",

        // Sales Staff Trend
        salesStaffTrend: "営業担当別月間人材獲得推移",
        salesStaffTrendSubtitle: "過去12ヶ月の営業担当者別新規人材数",

        // Nationality Distribution
        nationalityDistribution: "国籍分布",
        nationalityDistributionSubtitle: "人材の国籍別内訳",

        // Monthly New Talents
        monthlyNewTalents: "月間新規人材推移",
        monthlyNewTalentsSubtitle: "過去12ヶ月の新規追加人材数",
        newTalents: "新規追加人材",

        // Quarterly Stats
        quarterlyStats: "四半期別人材獲得数",
        quarterlyStatsSubtitle: "{{year}}年の四半期別実績",
        quarterlyTalents: "四半期別人材数",

        // Sales Staff Ranking
        salesStaffRanking: "営業担当者ランキング",
        salesStaffRankingSubtitle: "現在の担当人材数による順位",
        rank: "順位",
        salesStaffName: "営業担当",
        totalTalentsCount: "総人材数",
        employedCount: "在職中",
        pendingCount: "内定",
        applyingCount: "申請中",
        childcareLeaveCount: "育休",
        awaitingEntryCount: "待入社",
        resignedCount: "離職",
        peopleCount: "{{count}}人",
        attritionAnalysis: "離職率分析",
        attritionAnalysisSubtitle: "進歩状況が「離職」の人材を国籍・分野別に集計",
        attritionRate: "離職率",
        attritionRateByNationality: "国籍別離職率",
        attritionRateByField: "分野別離職率",
        attritionSalesStaffSummary: "営業担当: {{salesStaff}}",
        attritionSummary: "離職率: {{rate}}%（離職 {{resigned}}名 / 母数 {{total}}名）",
        attritionDateRangeSummary: "集計期間: {{start}} 〜 {{end}}",
        attritionNoData: "条件に一致するデータがありません",

        // New chart titles (可切换图表)
        salesStaffRevenueTitle: "営業担当別月間管理費収益推移",
        salesStaffRevenueSubtitle: "過去12ヶ月の営業担当者別管理費収益",
        fieldDistribution: "分野別人材分布",
        fieldDistributionSubtitle: "人材の分野別内訳",
        monthlyRevenue: "月間管理費収益推移",
        monthlyRevenueSubtitle: "過去12ヶ月の管理費収益",
        managementFeeRevenue: "管理費収益",
        yearOverYearComparison: "前年同期対比",
        yearOverYearComparisonSubtitle: "過去2年の四半期別実績比較",

        // Chart options (下拉选择选项)
        chartOption: {
          talentCount: "人材獲得数",
          revenue: "管理費収益",
          nationality: "国籍分布",
          field: "分野分布",
          newTalents: "月間新規追加",
          monthlyRevenue: "月間収益",
          quarterly: "本年度四半期",
          yearOverYear: "前年同期対比",
          pieChart: "円グラフ",
          stackedBar: "バーグラフ",
          bar: "バー",
          stackedBarMode: "バーグラフモード"
        }
      },

      // 通用表单反馈消息
      common: {
        unknownError: "予期せぬエラーが発生しました",
        requiredFieldsMissing: "必須項目を入力してください",
        createSuccess: "{{item}}を作成しました",
        createFailed: "{{item}}の作成に失敗しました",
        updateSuccess: "{{item}}を更新しました",
        updateFailed: "{{item}}の更新に失敗しました",
        deleteSuccess: "{{item}}を削除しました",
        deleteFailed: "{{item}}の削除に失敗しました",
        saveSuccess: "保存しました",
        saveFailed: "保存に失敗しました"
      },

      // Sales Analytics
      salesAnalytics: {
        title: "営業統計",
        loadError: "データの読み込みに失敗しました",
        errorOccurred: "エラーが発生しました",
        noData: "表示できるデータがありません",

        // Management Fee Statistics
        managementFeeStats: "管理費統計",
        totalTalentsCount: "在職人数",
        targetTalentsCount: "対象人材数",
        currentMonthTalentsCount: "当月管理費対象: {{count}}名",
        managementFeeNoChargeCount: "管理費無償設定: {{count}}名",
        managementFeeViewLabel: "統計視角",
        managementFeeViewOption: {
          current: "当月実績",
          rangeActual: "区間実績",
          rangeForecast: "区間見込",
          rangeCombined: "区間総合"
        },
        managementFeeViewRange: "統計期間: {{start}} 〜 {{end}}",
        viewTalentsCount: "{{view}}管理費対象: {{count}}名",
        totalMonthlyFee: "月間管理費総額",
        totalRangeFee: "区間管理費総額",
        averageFeePerTalent: "人材あたり平均管理費",
        medianFee: "管理費中央値",
        maxFee: "最高管理費",
        minFee: "最低管理費",
        projectedAnnualRevenue: "年間予想収益",
        startMonth: "開始月",
        endMonth: "終了月",
        clearDateFilters: "リセット",
        applyDateFilters: "適用",
        invalidDateRange: "開始月は終了月以前で指定してください",
        firstMonthFeeTotal: "首月管理費合計",
        firstMonthFeeCount: "首月管理費適用: {{count}}件",
        managementFeeCurrentViewHint: "当月実績は現在月のみ集計され、期間指定の影響を受けません。",
        managementFeeCurrentRangeDisabledHint: "当月実績では期間指定を使用しません。区間視角を選択すると有効になります。",
        billedMonths: "請求月数",
        pausedMonths: "休止月数",
        monthsUnit: "ヶ月",

        // Initial Cost Statistics
        initialCostStats: "初期費用統計",
        initialCostSyncLabel: "管理費と同じ期間を使用",
        initialCostTalentCount: "初期費用対象人数",
        initialCostCoverageRate: "入力率: {{rate}}%",
        initialCostNoChargeCount: "初期費無償設定: {{count}}名",
        initialCostChargeablePopulation: "集計対象母数: {{count}}名",
        totalInitialCost: "初期費用合計",
        averageInitialCost: "人材あたり平均初期費用",
        medianInitialCost: "初期費用中央値",
        maxInitialCost: "最高初期費用",
        minInitialCost: "最低初期費用",

        // Employment Status Distribution
        employmentStatusDistribution: "進歩状況分布",
        employmentStatusDistributionSubtitle: "担当人材の進歩状況別内訳",

        // Nationality Distribution
        nationalityDistribution: "国籍分布",
        nationalityDistributionSubtitle: "担当人材の国籍別内訳",

        // Field Distribution
        fieldDistribution: "分野分布",
        fieldDistributionSubtitle: "担当人材の分野別内訳",

        // Monthly New Talents
        monthlyNewTalents: "月間新規人材推移",
        monthlyNewTalentsSubtitle: "過去12ヶ月の新規追加人材数",
        newTalents: "新規追加人材",

        // Quarterly Stats
        quarterlyStats: "四半期別人材獲得数",
        quarterlyStatsSubtitle: "{{year}}年の四半期別実績",
        quarterlyTalents: "四半期別人材数"
      },

      // Accounting Analytics
      accountingAnalytics: {
        title: "会計統計",
        loadError: "データの読み込みに失敗しました",
        errorOccurred: "エラーが発生しました",

        // Date Filter
        dateFilter: "期間フィルター",
        startMonth: "開始月",
        endMonth: "終了月",
        apply: "適用",
        reset: "リセット",
        dateRangeError: "開始月は終了月以前で指定してください",

        // Key Metrics
        totalLoanAmount: "総借款金額",
        rentalLoanAmount: "賃貸貸付額",
        advanceLoanAmount: "立替金",
        totalRepaymentAmount: "総返済金額",
        remainingBalance: "未返済残高",
        totalBorrowers: "借款人数",
        fullyRepaidCount: "完済人数",
        unrepaidCount: "未完済人数",
        averageLoanAmount: "平均借款金額",

        // Line Charts
        loanTrend: "借款推移",
        repaymentTrend: "返済推移",
        combinedTrend: "借款・返済推移",
        loanAmount: "借款金額",
        repaymentAmount: "返済金額",

        // Pie Charts
        repaymentStatusDistribution: "返済状況分布",
        categoryDistribution: "貸付分類別内訳",
        organizationDistribution: "所属機関別分布",
        salesStaffDistribution: "責任担当別分布",

        // Bar Charts
        monthlyLoan: "月別借款統計",
        monthlyRepayment: "月別返済統計",
        quarterlyComparison: "四半期別比較"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    lng: 'ja', // デフォルトで日本語に設定
    debug: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
